module.exports = __webpack_public_path__ + "img/tingey-injury-law-firm-nSpj-Z12lX0-unsplash.fbb6ea40.jpg";